import { Button, Form } from "antd";
import { useTranslation } from "react-i18next";
import Input from "components/inputs";

const EmailForm = ({ formRef, loading, values, onFinish }) => {
  const { t } = useTranslation();

  return (
    <Form
      autoComplete="off"
      className="space-y-1"
      name="email"
      ref={formRef}
      initialValues={values}
      onFinish={onFinish}
    >
      <Input
        label={t("email")}
        name="email_address"
        required
        rules={[
          {
            pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g,
            message: t("validate-email"),
          },
        ]}
      />

      <Button
        loading={loading}
        disabled={loading}
        className={`${
          loading ? "disabled-button-medium" : "primary-button-medium"
        } justify-center items-center !mt-8`}
        block
        htmlType="submit"
      >
        {t("submit")}
      </Button>
    </Form>
  );
};
export default EmailForm;
